module.exports = __webpack_public_path__ + "static/media/gallery6.7da610ec.jpg";